import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Navbar } from '../../components/common/Navbar';
import { Footer } from '../../components/common/Footer';
import { Button } from '../../components/common/Button';
import { Badge } from '../../components/common/Badge';
import { NEWS_DATA } from '../../data/siteData';
import { SEO } from '../../components/common/SEO';

export default function NewsDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const item = NEWS_DATA.find((n) => n.slug === slug);

  if (!item) {
    return <Navigate to="/news" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-white text-navy">
      <SEO
        title={`${item.title}｜お知らせ`}
        description={item.summary}
        canonicalPath={`/news/${item.slug}`}
      />
      <Navbar />

      <main className="flex-1">
        <section className="bg-hero-gradient border-b border-surface-border py-12 md:py-16">
          <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
            <Link
              to="/news"
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-navy-muted hover:text-spaq-cyan-dark mb-6"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>お知らせ一覧へ戻る</span>
            </Link>

            <div className="flex flex-wrap items-center gap-3 mb-3">
              <span className="text-xs font-mono text-navy-muted">{item.date}</span>
              <Badge variant="cyan" size="sm">{item.category}</Badge>
              {item.isPastEvent && (
                <Badge variant="slate" size="sm">開催終了</Badge>
              )}
            </div>

            <h1 className="text-2xl sm:text-3xl font-bold text-navy leading-snug">
              {item.title}
            </h1>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl space-y-6">
            <div className="space-y-4 text-sm sm:text-base text-navy leading-relaxed">
              {item.content.map((p, idx) => (
                <p key={idx}>{p}</p>
              ))}
            </div>

            {item.relatedLink && (
              <div className="pt-6 border-t border-surface-border flex flex-wrap items-center justify-between gap-4">
                <Button
                  to={item.relatedLink.to}
                  variant="primary"
                  icon={<ArrowRight className="w-4 h-4" />}
                >
                  {item.relatedLink.label}
                </Button>
                <Button to="/news" variant="outline-dark">
                  お知らせ一覧へ戻る
                </Button>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
